<div class="row">
  <div class="col-6">
    <h2>Stores</h2>
  </div>
  <div class="col-sm-4" *ngIf="role == 'admin'">
    <input style="float: right; background-color: white" type="text" placeholder="Search Text" nbInput
      [(ngModel)]="word" (keyup)="onFilterKeySearch()" />
  </div>
  <div *ngIf="role != 'admin'" class="col-sm-6">
    <input style="float: right; background-color: white" type="text" placeholder="Search Text" nbInput
      [(ngModel)]="word" (keyup)="onFilterKeySearch()" />
  </div>
  <div class="col-sm-2">
    <button *ngIf="role == 'admin'" type="button" class="btn btn-primary px-4" style="float: right"
      (click)="addStores()">
      Add Store
    </button>
  </div>
</div>
<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th scope="col">S.No.</th>
            <th scope="col">Name</th>
            <th scope="col">PCname</th>
            <th scope="col">Address</th>
            <th scope="col">Visible</th>
            <th scope="col">Geofence</th>
            <th scope="col">Age Limit</th>
            <th scope="col">POS</th>
            <th scope="col">Opening Hours</th>
            <th scope="col">Url</th>
            <th scope="col">View</th>
            <th scope="col">Action</th>
          </tr>
        </thead>

        <!-- <tbody *ngIf="role == 'manager'">
                    <tr
                        *ngFor="let store of storeList | paginate: { itemsPerPage: 10, currentPage: page, totalItems: total }; let i= index">
                        <td>{{(page - 1) * count + i + 1 + ((page - 1) * count)}}</td>
                        <td>{{store.storeData?.storeName}}</td>
                        <td class="internal-backend-key">{{store.storeData?.internalBackendUrl}}</td>
                        <td class="internal-backend-key">{{store.storeData?.internalBackendKey}}</td>
                        <td>{{store.storeData?.address}}</td>
                        <td>{{store.storeData?.location?.coordinates[0]}}</td>
                        <td>{{store.storeData?.location?.coordinates[1]}}</td>
                        <td><i class="fas fa-qrcode me-2 point" (click)="open(store?.storeData?._id)"></i> </td>
                        <td> <nb-icon style="cursor: pointer;" (click)="editStore(store.storeData._id)" class="right"
                                icon="edit-outline"></nb-icon>
                            <nb-icon *ngIf="role=='admin'" style="cursor: pointer;" (click)="deletStore(store._id)"
                                class="right deleteIcon" icon="trash-outline"></nb-icon>
                        </td>
                    </tr>
                </tbody> -->

        <tbody>
          <tr *ngFor="
              let store of storeList
                | paginate
                  : { itemsPerPage: 10, currentPage: page, totalItems: total };
              let i = index
            ">
            <td>{{ (page - 1) * count + i + 1 + (page - 1) * count }}</td>
            <td>{{ store.storeName }}</td>
            <td>{{ store.PCname }}</td>
            <td>{{ store.address }}</td>
            <td>{{ store.isVisible }}</td>
            <td>{{ store.geofenceCheck }}</td>
            <td>{{ store.ageLimit }}</td>
            <td>
              <nb-badge [text]="store.posEnabled ? 'Enabled' : 'Disabled'" 
                        [status]="store.posEnabled ? 'success' : 'basic'">
              </nb-badge>
            </td>
            <td><i class="fa-solid fa-hourglass-start" (click)="openTimingDialog(store._id)"></i></td>
            <td> <i class="fa-regular fa-eye" (click)="openDialog(store._id)"></i></td>
            <td>
              <i class="fas fa-qrcode me-2 point" (click)="open(store._id)"></i>
            </td>
            <td class="action-column">
              <nb-icon style="cursor: pointer" (click)="storeOpening(store._id)" class="rightlock"
                icon="lock-outline"></nb-icon>
              <nb-icon style="cursor: pointer" (click)="editStore(store._id)" class="right"
                icon="edit-outline"></nb-icon>
              <nb-icon style="cursor: pointer" (click)="openEcommerceAdmin(store._id)" class="right"
                icon="shopping-cart-outline" nbTooltip="Ecommerce Admin"></nb-icon>
              <nb-icon style="cursor: pointer" (click)="openPosTerminals(store._id)" class="right"
                icon="monitor-outline" nbTooltip="POS Terminals"></nb-icon>
              <nb-icon *ngIf="role == 'admin'" style="cursor: pointer" (click)="copyStore(store)"
                class="right" icon="copy-outline" nbTooltip="Copy Store"></nb-icon>
              <nb-icon *ngIf="role == 'admin'" style="cursor: pointer" (click)="deletStore(store._id)"
                class="right deleteIcon" icon="trash-outline"></nb-icon>
              <nb-icon style="cursor: pointer" (click)="viewNfcMonitoring(store._id)" class="right"
                icon="activity-outline" nbTooltip="NFC Reader Monitoring"></nb-icon>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination-controls class="pagination" [responsive]="true" (pageChange)="pageChanged($event)"
        previousLabel="Prev" nextLabel="Next"></pagination-controls>
    </nb-card-body>
  </nb-card>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>